import {Component, inject, OnInit} from '@angular/core';
import {AuthService} from '../auth-service';
import {Router} from '@angular/router';
import {LocalizationPipePipe} from '../../localization/control/localisation-pipe-pipe';

@Component({
  selector: 'app-callback',
  imports: [LocalizationPipePipe],
  templateUrl: './login-callback.html',
  styleUrl: './login-callback.scss'
})
export class LoginCallback implements OnInit {
  private readonly authService: AuthService = inject(AuthService)
  private readonly router: Router = inject(Router)

  async ngOnInit(): Promise<void> {
    try {
      await this.authService.handleCallback();
      await this.router.navigate(['/']);
    } catch (error) {
      console.error('LoginCallback processing failed:', error);
      await this.router.navigate(['/login-error']);
    }
  }

}
